// src/components/BannerComponent.js
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { setActiveByKey, setBannerFlagByKey } from '../SharedContextStore/slices/notifications';
import { useAppSelector } from '../hooks';
import { Box, Button, Typography, useMediaQuery, useTheme } from '@mui/material';
import { getAltText, getAriaLabel, getImageSrc } from './bannerDisplayPages';
import { BannerNotificationContent,DslmigratorContent } from '../SharedComponents/contents';
import closeIcon from "../assets/images/tostCloseIcon.svg";
import { getPageIdentifier } from './pageIdentifier';
import { Link, useLocation } from 'react-router-dom';
import { replaceJSX, chatClick } from './utils';
import ReferalDialog from '../SharedComponents/notificationBannerView/referaldialog';
import { ExtoleReferal } from '../SharedComponents/referalLink/extoleReferal';
import { isAfterBillingDate } from '../../../shared/utils/dateUtils';
import { addEneventGTM, sendEventGTMLog } from './googleTags';
import AppDownlaodDialog from "../SharedComponents/notificationBannerView/appdownloadDialog";
import '../SharedComponents/notificationBannerView/notificationBannerView.scss';
import useBrightspeedHeaders from '../hooks/useBrightspeedHeader';
import { EC_DW_LOGGING_STEPS } from "../../../shared/utils/Constants";
import { useNavigate } from "react-router-dom";
// import activeBanners from './bannerNotificationTest';
import { setPayNowNotificationBtnClicked } from "../SharedContextStore/slices/notificationDetails";
import { sendEventLog } from './app-log';
import {getCTLPlanDetails} from "../SharedContextStore/slices/planDetails"
import useBrightspeedUser from "../hooks/useUser";
import DwLogutil from "./DwLogutil";
import { getInternetSpeed } from "../Utils/discountBannerUtils";

const BannerComponent = (props) => {
  const dispatch = useDispatch();
  const banners = useAppSelector((state) => state.mySlice);
  const currentPage = getPageIdentifier();
  const { sessionId } = useAppSelector((state) => state?.user);
  const headers = useBrightspeedHeaders();
  const userType = useBrightspeedUser();
  const location = useLocation();
  const navigate = useNavigate();

  const payInCash = process.env.REACT_APP_ENABLE_PAY_IN_CASH === "true" ? true : false
  const isOutageBannerEnabled = process.env.REACT_APP_ENABLE_OUTAGE_BANNER === "true";
  const dslfibermigratorflow = process.env.REACT_APP_DSL_Fiber_MIGRATOR_CHANGES === "true" ? true : false;
  const { ctlPlanDetails, ctlLoading, ctlFetched } = useAppSelector(
    (state) => state?.planDetails
  );
  const { upcomingAppointment } = useAppSelector((state) => state?.upComingAppointment);
  const { submitOrderWithTechInstall, currentProductData } = useAppSelector((state) => state?.getAccordionStateSlice);
  const internetChangeNewPlanSpeed = currentProductData?.offerResponse?.offerDetails?.productName;
  const enablePPFChangeFlow = process.env.REACT_APP_ENABLE_CHANGEFLOW === "true";
  const enableWifi7 = process.env.REACT_APP_ENABLE_WIFI7 === "true"
  const DECOMISSION_CHANGE = process.env.REACT_APP_DECOMISSION_CHANGE === "true" ? true : false;
  const user = useAppSelector((state) => state?.user?.data);
  const activeBanners = banners?.filter(
    (banner) =>
      banner?.active === true &&
      banner?.Bannerflag !== true &&
      banner?.displaypages?.includes(currentPage)
      
  );
   useEffect(() => {
    if (
      !ctlPlanDetails && !ctlLoading && !ctlFetched && user?.billingAccountNumber &&
      (userType?.isCTLMigratedPostpay || userType?.isCTLMigratedPrepay ||
        userType?.isCTLPostPayUser || userType?.isCTLPrepayUser
      )
    ) {
      dispatch(getCTLPlanDetails(user));
    }
  }, [ctlPlanDetails, ctlLoading, ctlFetched, user?.billingAccountNumber, userType?.isCTLMigratedPostpay, userType?.isCTLMigratedPrepay, userType?.isCTLPostPayUser, userType?.isCTLPrepayUser, dispatch]);
 

  // Priority - 1, 5, 7, 8, 10  | JeopardyBanner, Initial-login-CTL-Welcome, Initial-login-CTL-User, User-Suspended-Vacation & changePlanPreInstallation
 
  const {
      isUserOnJeopardy
    } = useAppSelector((state) => state.user);
  const isBusinessAccount = user?.accountType?.toLowerCase()?.includes("business");

  // Priority - 2 & 9 | CCBanner & disableChangePlanFeatureNotification
  const { paymentMethods: listOfPaymentMethodRes,
    nextCreditCardExpirationDate: isCreditCardExpirationNotificationShow,
    nextCreditCardExpirationAllDetail: nextMonthCreditCardExpDetails } = useAppSelector((state) => state.paymentMethods);

  // Priority - 3 & 4 | RoadBoreBanner & BDBanner
  const { burriedDropDetails: burriedDropDetailsResp } = useAppSelector((state) => state?.burriedDrop);
  const details = burriedDropDetailsResp;
  const addressQualificationSliceData = useAppSelector((state) => state?.addressQualification?.data);
  //const preSurvey = addressQualificationSliceData?.addressQualification?.entity?.preSurveyRequired;
  const dropType = addressQualificationSliceData?.addressQualification?.entity?.dropType;
  const jobStatus = details?.bswJobStatus?.toUpperCase();
  const currentDate = new Date();
  const burriedDropServiceDate = burriedDropDetailsResp && burriedDropDetailsResp?.bswDueDate && new Date(burriedDropDetailsResp?.bswDueDate);

  // Priority - 6 | ReferalBanner
  const AddressQualificationSiteId = useAppSelector((state) => state?.addressQualification?.data?.addressQualification?.entity?.siteId);

  //Priority 11 - | changePlanPending
  const { serviceDetails } = useAppSelector((state) => state.serviceDetails);
   const iwpServiceExists = serviceDetails?.iwpServiceExists || false;
 
  // Priority - 12 | Download-Banner
  const appTheme = useTheme();
  const isMobileOrTabView = useMediaQuery(appTheme.breakpoints.down("md"));

  // Priority - 13 | PaymentArrangements
  const userCompanyName = useAppSelector((state) => state?.user?.companyName);

  // Priority - 14 | ModemRestarted
  const networkSetting = useAppSelector((state) => state?.networkSetting);

  //Priority 15 - AutoPayRemoval
  const paymentHistoryRes = useAppSelector((state) => state.paymentHistoryForPA)
  const planDetailsRes = useAppSelector((state) => state?.planDetails?.planDetails);
  const pendingInstallments = paymentHistoryRes?.paymentHistory?.treatment[0]?.installment?.filter((installment) => installment.status.toUpperCase() !== 'PAID');

  //Priority 16 - qbpBanner
  const qbpFlag = ""

  const addressQualification = useAppSelector((state) => state?.addressQualification?.data);
  const fibreQualified = addressQualification?.addressQualification?.entity?.brightSpeedFiberIndicator;
  const existingUser = addressQualification?.addressQualification?.entity?.existingService;
  const workingNetworkType = addressQualification?.addressQualification?.entity?.workingNetworkType?.[0]?.toUpperCase();
  const fiberVoiceEligible = addressQualification?.addressQualification?.entity?.fiberVoiceEligible;
  const decomStatus = addressQualification?.addressQualification?.entity?.decomStatus;
  const isGrandFatherAccount = decomStatus?.toUpperCase() === "GRANDFATHERED";
  const isDiscountinuedAccount = decomStatus?.toUpperCase() === "DISCONTINUED";

  // Priority - 1 | outageBanner & outageResolveBanner
 
 const {openOutage: openOutageFlag, closeOutage: restoreOutageFlag, noOutage, hideclose,outageDate, outageTime } = useAppSelector((state)=>state.outageInformation);
 
 

  const onCloseBanner = (bannerKey) => {
    dispatch(setBannerFlagByKey({ key: bannerKey, value: true }));
  };

  // The logic for setting flags and activation
  const ActivateBanner = (condition) => { 
    dispatch(setActiveByKey({ key: condition, value: true }));
  };
  const ResetBanner = (condition) => {
    dispatch(setActiveByKey({ key: condition, value: false }));
  };

 

  const isctlUser = headers?.siteId?.toUpperCase() === "CTL";
  
  const plan = ctlPlanDetails?.[0];
  const internetDesc = plan?.internet?.productIdDescription;
  const pots = plan?.pots;
  const potsHasPhone = pots?.length > 0 && Boolean(pots[0]?.phoneNo);
  const potsCheck = pots?.length > 0;
  const potsPlanonly = !internetDesc && potsHasPhone;

  const DSLplan = Boolean(internetDesc) && (!potsHasPhone);
  const potsPlan = potsCheck && potsHasPhone;
  const DSLplanAndPotsPlan = Boolean(internetDesc) && potsHasPhone;
  const multiLinePots = pots?.length > 1 ? true : false;
  const orderStatus = upcomingAppointment?.upcomingAppointments[0]?.orderDetails?.pastAppointment[0]?.orderStatus
  const DSL_BANNER_CHANGE_ENABLED = process.env.REACT_APP_BANNER_CHANGES === "true" ? true : false;
  const copperuser_with_fiberQualified = isctlUser && (existingUser === true) && (fibreQualified?.toUpperCase() === "QUALIFIED") && (workingNetworkType?.toUpperCase() === "COPPER");
  const completed_order = (orderStatus?.toUpperCase()?.includes("COMPLETED"));
  const active_user = user?.currentStatus?.toUpperCase() === "ACTIVE";
  const vacationPause = user?.suspendReason?.toUpperCase() === "VACATION";
  const jeopardyUser = planDetailsRes?.jeopardyFlag === "Y" ? true : false;
  const active_copperuser_with_fiberQualified = copperuser_with_fiberQualified && active_user && completed_order;

  const BRSPD_FIBER_USER = (user?.networkType?.toUpperCase() === "XGSPON") && (headers?.siteId?.toUpperCase() === "BS");
  const QUANTUM_FIBER_USER = (headers?.siteId?.toUpperCase() === "QF");
  const isOutageCheck = useAppSelector((state) => state.isOutageCheck?.isOutageCheck);

  useEffect(() => {
    
    // Priority - 1 | JeopardyBanner 
    if (isUserOnJeopardy && !(user?.isSuspended) && user?.billingType?.toUpperCase() === "POSTPAID") {
      ActivateBanner('JeopardyBanner');
    }

    // Priority - 1 | User-Suspended/Jeopardy for prepaid users
    // if (user?.isSuspended && user?.billingType?.toUpperCase() !== "POSTPAID" && !isBusinessAccount) {
    if (user?.isSuspended && !isBusinessAccount && user?.currentStatus?.toUpperCase() !== "INACTIVE") {
      ActivateBanner('User-Suspended');
    }

    // Priority - 1 | User-Suspended/Jeopardy for prepaid business users
    // if (user?.isSuspended && user?.billingType?.toUpperCase() !== "POSTPAID" && isBusinessAccount) {
    if (user?.isSuspended && isBusinessAccount) {
      ActivateBanner('BUser-Suspended');
    }
    
    // Priority - 1 | outageBanner
    if (openOutageFlag && isOutageBannerEnabled) {
      ActivateBanner('outageBanner');
    }

    // Priority - 1 | outageRestoreBanner
    if (restoreOutageFlag && isOutageBannerEnabled) {
      ActivateBanner('outageRestoreBanner');
    }

    // Priority - 1 | NoOutageBanner
    if (BRSPD_FIBER_USER && noOutage && isOutageCheck) {
      DwLogutil({stepName:EC_DW_LOGGING_STEPS?.nooutage_bs_banner_shown});
      ActivateBanner("BRSPD_No_Outage");
    }

    // Priority - 1 | NoOutageBanner
    if ((QUANTUM_FIBER_USER || isctlUser) && noOutage && isOutageCheck) {
      DwLogutil({stepName:EC_DW_LOGGING_STEPS?.nooutage_othr_banner_shown});
      ActivateBanner("Othrs_No_Outage");
    }

    // Priority - 2 | CCBanner
    if (isCreditCardExpirationNotificationShow &&
      nextMonthCreditCardExpDetails?.id &&
      !listOfPaymentMethodRes?.isContainPaypalCard) {
      ActivateBanner('CCBanner');
    }

    // Priority - 3 | RoadBoreBanner
    if (details?.bswJobStatus?.toUpperCase() !== "COMPLETE" &&
      details?.bswJobStatus?.toUpperCase() !== "FINAL REVIEW" &&
      (dropType?.toUpperCase() === "ROAD BORE") &&
      props?.displayOnly?.includes("RoadBoreBanner")) {
      ActivateBanner('RoadBoreBanner');
    }

    // Priority - 4 | BDBanner
    if (jobStatus && jobStatus?.toUpperCase() !== "COMPLETE" && jobStatus?.toUpperCase() !== "CANCELLED" &&
      (dropType?.toUpperCase() !== "ROAD BORE" /* && !dropType */ && dropType !== undefined) && details?.bswDueDate &&
      currentDate < burriedDropServiceDate) {
      ActivateBanner('BDBanner');
    }

    // Priority - 5 | Initial-login-CTL-Welcome
    if (user?.billingAccountNumber &&
      localStorage?.getItem("MI-CTL-FT-WELCOME-MSG")?.trim()?.toUpperCase() === user?.email?.trim()?.toUpperCase() &&
      user?.migratedAccount?.toUpperCase() === "Y") {
      ActivateBanner('Initial-login-CTL-Welcome');
    }

    if(process.env.REACT_APP_POST_EMBARGO_NOTIFICATION==="true" && localStorage.getItem("EMBARGO_BANNER_FOR_CTL")=="true"){      
      ActivateBanner('EMBARGO_BANNER');
    }

    // Priority - 6 | ReferalBanner
    // removed ReferalBanner on 5th Dec 2025 Prod drop
    // if (AddressQualificationSiteId && !["CENTURY LINK", "CTL_QUALIFIED", "CTL", "4GLTE"]?.includes(AddressQualificationSiteId?.toUpperCase())
    //     && !DSL_BANNER_CHANGE_ENABLED ) {
    //   ActivateBanner('ReferalBanner');
    // }

    // Priority - 7 | Initial-login-CTL-User
    if (user?.billingAccountNumber &&
      localStorage?.getItem("MI-CTL-FT-LOGIN") === user?.email &&
      user?.migratedAccount?.trim()?.toUpperCase() === "Y") {
      ActivateBanner('Initial-login-CTL-User');
    }

    // Priority - 8 | User-Suspended-Vacation
    if (user?.suspendEndDate?.trim() && user?.suspendEndDate?.trim() !== "" &&
      user?.suspendStartDate?.trim() && user?.suspendStartDate?.trim() !== "" &&
      (user?.currentStatus?.toUpperCase() === "ACTIVE" || user?.suspendReason?.toUpperCase() === "VACATION")) {
      if ((user?.suspendReason?.trim() === "" || user?.suspendReason === null || user?.suspendReason === undefined)) {
        addDwLogs(EC_DW_LOGGING_STEPS?.empty_suspend_reason,"");
      }
      else {
      ActivateBanner('User-Suspended-Vacation');
      }
    }

    // Priority - 9 | disableChangePlanFeatureNotification
    if (listOfPaymentMethodRes?.disableChangePlanFeature &&
      props?.displayOnly?.includes("disableChangePlanFeatureNotification")) {
      ActivateBanner('disableChangePlanFeatureNotification');
    }

    // Priority - 10 | changePlanPreInstallation
    if (user?.currentStatus?.toUpperCase() !== "ACTIVE" &&
      props?.displayOnly?.includes("changePlanPreInstallation")) {
      ActivateBanner('changePlanPreInstallation');
    }

    // Priority - 11 | changePlanPending
    if (serviceDetails?.pendingServiceChange &&
      props?.displayOnly?.includes("changePlanPending")) {
      ActivateBanner('changePlanPending');
    }

    // Priority - 12 | Download-Banner
    if (isMobileOrTabView === true) {
      ActivateBanner('Download-Banner');
    }
    else {
      ResetBanner('Download-Banner')
    }

    // Priority - 13 | PaymentArrangements
    if (
      props?.displayOnly?.includes("PaymentArrangements") &&
      userCompanyName?.toUpperCase() === "CENTURY LINK") {
      ActivateBanner('PaymentArrangements');

    }

    // Priority - 14 | ModemRestarted
    if (networkSetting?.isModemReStarted &&
      props?.displayOnly?.includes("ModemRestarted")) {
      ActivateBanner('ModemRestarted');
    }

    // Priority - 15 | AutoPayRemoval
    if (paymentHistoryRes?.paymentHistory?.treatment[0]?.installment !== undefined &&
      planDetailsRes?.autoPayIndicator?.toUpperCase() === "ZN" &&
      user?.billingType?.toUpperCase() === "POSTPAID" && pendingInstallments?.length) {
      ActivateBanner('AutoPayRemoval');
    }

    // Priority - 16 | qbpBanner
    if (qbpFlag
      // need to check weather the user in qbp page or not?
    ) {
      ActivateBanner('qbpBanner');
    }
   // Priority - 19 | NEW_LOGIN
    if (props?.displayOnly?.includes("NEW_LOGIN")) {
      ActivateBanner("NEW_LOGIN");
    }
 
    // removed on 5th Dec 2025 Prod Drop
    // if (copperuser_with_fiberQualified && active_user && !DSL_BANNER_CHANGE_ENABLED && !(openOutageFlag && isOutageBannerEnabled)) {
    //   ActivateBanner('DSL-Migrator');
    // }
    if (enableWifi7 && !isUserOnJeopardy && active_user && submitOrderWithTechInstall) {
      ActivateBanner("NEW_EQUIP_INSTALL")
    }
   
    if (userType?.dslMigrationPending && planDetailsRes?.jeopardyFlag !== "Y" && active_user && dslfibermigratorflow) {
      addDwLogs(EC_DW_LOGGING_STEPS?.migration_pending_banner_shown);
      ActivateBanner("FIBER_MIGRATION_PENDING")
    }

    if (userType?.dslMigrationCompletedBanner && planDetailsRes?.jeopardyFlag !== "Y" && active_user && dslfibermigratorflow) {
      addDwLogs(EC_DW_LOGGING_STEPS?.migration_success_banner_shown);
      ActivateBanner("FIBER_MIGRATION_SUCCESS")
    }

    if (BRSPD_FIBER_USER) {
      ActivateBanner("BRSPD_VAS");
    }

    if (QUANTUM_FIBER_USER) {
      ActivateBanner("FQF_VAS");
    }

    if (addressQualification?.addressQualification?.entity?.virtualMduFlag) {
      ActivateBanner('InstallationExtendBanner');
    }

  }, [dispatch, user, isCreditCardExpirationNotificationShow, nextMonthCreditCardExpDetails, listOfPaymentMethodRes, burriedDropDetailsResp, openOutageFlag, restoreOutageFlag, noOutage,
    AddressQualificationSiteId, addressQualification, serviceDetails, isMobileOrTabView, userCompanyName, networkSetting, paymentHistoryRes, planDetailsRes, pendingInstallments, qbpFlag, currentPage,
    copperuser_with_fiberQualified, active_user, completed_order, DSLplan, potsPlan, userType]);

   useEffect(() => { 
    const isCtlPlanReady = planDetailsRes;
    if(isCtlPlanReady) {
    
       // Inside wire protection Migrator Banner
    if (active_copperuser_with_fiberQualified && (potsPlanonly || DSLplanAndPotsPlan) && (fiberVoiceEligible)  && iwpServiceExists && !(openOutageFlag && isOutageBannerEnabled)
       && (DSL_BANNER_CHANGE_ENABLED || dslfibermigratorflow) && planDetailsRes?.jeopardyFlag !== "Y") {
      
      addDwLogs(EC_DW_LOGGING_STEPS?.iwp_ineligible_migrator);
      ActivateBanner('IWP-InEligible');
    }
    }
   }, [addressQualification,serviceDetails,ctlPlanDetails,openOutageFlag,isOutageBannerEnabled, planDetailsRes]);

  useEffect(() => {
    const isCtlPlanReady = planDetailsRes;
    if(isCtlPlanReady && ctlPlanDetails?.length > 0) {
    // Ineligible Migrator Banner - DAY-5441
    if (DECOMISSION_CHANGE &&
        active_copperuser_with_fiberQualified &&
       ((potsPlanonly || DSLplanAndPotsPlan) && (isGrandFatherAccount || isDiscountinuedAccount)) && 
       (fiberVoiceEligible && !multiLinePots || (!fiberVoiceEligible  && !multiLinePots))  &&
      !iwpServiceExists && 
      !(openOutageFlag && isOutageBannerEnabled)
       && (DSL_BANNER_CHANGE_ENABLED || dslfibermigratorflow) && planDetailsRes?.jeopardyFlag !== "Y") {
      addDwLogs(EC_DW_LOGGING_STEPS?.ineligible_migrator);
      ActivateBanner('POTS-Migrator-InEligible');
    }
    
    // need to remove this while decomission deployement
    if (!DECOMISSION_CHANGE && active_copperuser_with_fiberQualified && (potsPlanonly || DSLplanAndPotsPlan) && (fiberVoiceEligible && multiLinePots || (!fiberVoiceEligible  && multiLinePots))  && !iwpServiceExists && !(openOutageFlag && isOutageBannerEnabled)
       && (DSL_BANNER_CHANGE_ENABLED || dslfibermigratorflow) && planDetailsRes?.jeopardyFlag !== "Y") {
      addDwLogs(EC_DW_LOGGING_STEPS?.ineligible_migrator);
      ActivateBanner('POTS-Migrator-InEligible');
    }
    // need to remove this while decomission deployement
    const shouldShowEligibleMigratorBanner =
      userType?.dslMigratorEligible;
    if (shouldShowEligibleMigratorBanner) {
    // Eligible Migrator Banner - DSL & POTS
    if (active_copperuser_with_fiberQualified && DSLplanAndPotsPlan && fiberVoiceEligible && !multiLinePots && !iwpServiceExists && !(openOutageFlag && isOutageBannerEnabled )
       && (DSL_BANNER_CHANGE_ENABLED || dslfibermigratorflow) && planDetailsRes?.jeopardyFlag !== "Y") {
      addDwLogs(EC_DW_LOGGING_STEPS?.dsl_and_pots_migrator);
      ActivateBanner('DSL-POTS-Migrator-Eligible');
    }

    // Eligible Migrator Banner-POTS
    if (active_copperuser_with_fiberQualified && potsPlanonly && fiberVoiceEligible && !multiLinePots && !iwpServiceExists && !(openOutageFlag && isOutageBannerEnabled )
       && (DSL_BANNER_CHANGE_ENABLED || dslfibermigratorflow) && planDetailsRes?.jeopardyFlag !== "Y") {
      addDwLogs(EC_DW_LOGGING_STEPS?.pots_only_eligible_migrator);
      ActivateBanner('POTS-Migrator-Eligible');
    }

    // Eligible Migrator Banner - DSL
    if (active_copperuser_with_fiberQualified && DSLplan && !iwpServiceExists && !(openOutageFlag && isOutageBannerEnabled )
       && (DSL_BANNER_CHANGE_ENABLED || dslfibermigratorflow) && planDetailsRes?.jeopardyFlag !== "Y") {
      addDwLogs(EC_DW_LOGGING_STEPS?.dsl_only_eligible_migrator);
      ActivateBanner('DSL-Migrator-Eligible');
    }
  }
    else {
      ResetBanner('DSL-Migrator-Eligible');
      ResetBanner('POTS-Migrator-Eligible');
      ResetBanner('DSL-POTS-Migrator-Eligible');    
    }
}
    }, [planDetailsRes,iwpServiceExists,ctlPlanDetails,openOutageFlag,isOutageBannerEnabled,addressQualification,multiLinePots, userType?.dslMigratorEligible]);

  useEffect(() => {
    // Priority - 19 | New-Login
    if (props?.displayOnly?.includes("NEW_LOGIN")) {
      ActivateBanner("NEW_LOGIN");
    }
  }, [props?.displayOnly]);

  const bannerNotificationContent = BannerNotificationContent();
  const dslBanner = DslmigratorContent();
  const bannerContent = bannerNotificationContent?.entry;
  const dslmigratornewbanner = bannerNotificationContent?.entry
  const isProd = process.env.REACT_APP_ENV === "production";
  const referalBannerContent =  bannerContent?.ReferalBannerBlock?.ReferalBanner ;
  // DW Logs
  const addDwLogs = (step) => {
    if (step) {
       DwLogutil({ stepName: step })
    }
  };

  const [referalDialogOpen, setReferalDialogOpen] = useState(false);
  const [showAppDialog, setShowAppDialog] = useState(false);

  return (
    <>
      {activeBanners.length > 0 &&
        <Box className="notificationBox"
          sx={
            getImageSrc(activeBanners[0]?.key) === null 
              ? { margin: '40px auto 40px auto' }
              : {}
          }
        >
          <Box className="warnImg">
            {getImageSrc(activeBanners[0]?.key) !== null && (
            <img
              alt={getAltText(activeBanners[0]?.key)}
              src={getImageSrc(activeBanners[0]?.key)}
              aria-label={getAriaLabel(activeBanners[0]?.key)}
            />)}
          </Box>
          <Box className="warnInfo">
            <Box
              className="warnInfoContent"
              sx={{
                ml: 1,
                fontSize: 16,
                fontWeight: 600,
                color: "#fff",
                padding: "10px 0 10px 0",
              }}
            >

              {activeBanners[0]?.key === "JeopardyBanner" && currentPage === "home" && (
                user?.currentStatus === "Suspended"
                  ? <Box className="notificationBannerWithCta">
                    <Typography paragraph variant="body1" className="m-0">
                      {bannerContent?.JeopardyBanner?.homePage?.Suspended?.desc}
                    </Typography>
                    <Box>
                      <Link role="button" className="anchorButton" to="/my-bills/quick-bill-payments">{" "}
                        {bannerContent?.JeopardyBanner?.homePage?.Suspended?.cta_pay_online}</Link>
                      <Link role="button" className="anchorButtonSecondary" to="/non-auth-payment-arrangement">{" "}{bannerContent?.JeopardyBanner?.homePage?.Suspended?.cta_pa}</Link>
                    </Box>
                  </Box>
                  : <Box className="notificationBannerWithCta">
                    <Box><Typography paragraph variant="body1">
                      {bannerContent?.JeopardyBanner?.homePage?.Non_suspended?.desc1}
                    </Typography>
                      <ul className="notificationList">
                        <li>{bannerContent?.JeopardyBanner?.homePage?.Non_suspended?.bullet_point_one}</li>
                        <li>{bannerContent?.JeopardyBanner?.homePage?.Non_suspended?.bullet_point_two}</li>
                      </ul>
                    </Box>
                    <Box>
                      <Link role="button" className="anchorButton" to="/my-bills/quick-bill-payments">{bannerContent?.JeopardyBanner?.homePage?.Non_suspended?.cta_pay_online}</Link>
                      <a role="button" className="anchorButtonSecondary" href="/non-auth-payment-arrangement" target="_blank" aria-label="Payment arrangement opens in new tab" rel="noopner noreferrer">{bannerContent?.JeopardyBanner?.homePage?.Non_suspended?.cta_pa}</a>
                    </Box>
                  </Box>
              )}

              {activeBanners[0]?.key === "JeopardyBanner" && currentPage === "plan-details" && (
                <>{user?.currentStatus === "Suspended" ? (
                  <Box className="notificationBannerWithCta">
                    <Typography paragraph variant="body1">
                      {bannerContent?.JeopardyBanner?.plandetailsPage?.Suspended?.desc}
                    </Typography>
                    <Link role="button"
                      onClick={() => {
                        if (user?.billingSystem?.toUpperCase() === "ZUORA") {
                          addDwLogs(EC_DW_LOGGING_STEPS?.pay_now_attempted, "Suspended");
                          sendEventLog(EC_DW_LOGGING_STEPS?.pay_now_attempted, { "reason": "Suspended" });
                          sendEventGTMLog(`${EC_DW_LOGGING_STEPS?.pay_now_attempted}-Suspended}`, headers?.siteId || userCompanyName);
                        }
                      }}
                      className="anchorButton"
                      to={user?.billingType?.toUpperCase() === "POSTPAID" ? "/my-bills/quick-bill-payments" : "/my-bills/view-payments"}
                    >
                      {bannerContent?.JeopardyBanner?.plandetailsPage?.Suspended?.cta_make_payment}
                    </Link>
                  </Box>
                ) : (
                  <Box className="notificationBannerWithCta">
                    <Typography paragraph variant="body1">
                      {bannerContent?.User_Suspended?.planDetails?.jeopardy}
                    </Typography>
                    <Link role="button"
                        onClick={() => {
                          if (user?.billingSystem?.toUpperCase() === "ZUORA") {
                            addDwLogs(EC_DW_LOGGING_STEPS?.pay_now_attempted, "Suspended");
                            sendEventLog(EC_DW_LOGGING_STEPS?.pay_now_attempted, { "reason": "Suspended" });
                            sendEventGTMLog(`${EC_DW_LOGGING_STEPS?.pay_now_attempted}-Suspended}`, headers?.siteId || userCompanyName);
                          }
                        }}
                      className="anchorButton"
                      to={user?.billingType?.toUpperCase() === "POSTPAID" ? "/my-bills/quick-bill-payments" : "/my-bills/view-payments"}
                    >
                      {bannerContent?.User_Suspended?.planDetails?.cta_make_payment}
                    </Link>
                  </Box>
                )}</>
              )}
              {/* Cashpayment small business Suspended/Jeopardy status- dashboard */}
              {activeBanners[0]?.key === "BUser-Suspended" && currentPage === "home" && (
                user?.currentStatus === "Suspended" ?
                  <Box className="notificationBannerWithCta">
                    <Typography paragraph variant="body1">
                      {bannerContent?.smallBusinessSuspended?.desc}
                    </Typography>
                    <Link role="button"
                      onClick={() => {
                        if (user?.billingSystem?.toUpperCase() === "ZUORA") {
                          addDwLogs(EC_DW_LOGGING_STEPS?.pay_now_attempted, "Suspended");
                          sendEventLog(EC_DW_LOGGING_STEPS?.pay_now_attempted, { "reason": "Suspended" });
                          sendEventGTMLog(`${EC_DW_LOGGING_STEPS?.pay_now_attempted}-Suspended}`, headers?.siteId || userCompanyName);
                        }
                      }}
                      className="anchorButton"
                      to="/my-bills/view-payments"
                    >
                      {bannerContent?.smallBusinessSuspended?.cta_make_payment}
                    </Link>
                  </Box>
                  :
                  <Box className="notificationBannerWithCta">
                    <Typography paragraph variant="body1">
                      {bannerContent?.smallBusinessJeopardy?.desc}
                    </Typography>
                    <Link role="button"
                      onClick={() => {
                        if (user?.billingSystem?.toUpperCase() === "ZUORA") {
                          addDwLogs(EC_DW_LOGGING_STEPS?.pay_now_attempted, "Suspended");
                          sendEventLog(EC_DW_LOGGING_STEPS?.pay_now_attempted, { "reason": "Suspended" });
                          sendEventGTMLog(`${EC_DW_LOGGING_STEPS?.pay_now_attempted}-Suspended}`, headers?.siteId || userCompanyName);
                        }
                      }}
                      className="anchorButton"
                      to="/my-bills/view-payments"
                    >
                      {bannerContent?.smallBusinessJeopardy?.cta_make_payment}
                    </Link>
                  </Box>
              )}

              {activeBanners[0]?.key === "User-Suspended" && currentPage === "home" && (
                <>
                  {user?.currentStatus === "Suspended" ? (
                    <Box className="notificationBannerWithCta">
                      <Typography paragraph variant="body1" className="m-0">
                        {payInCash ? bannerContent?.User_Suspended?.homePage?.suspended_cash :
                          bannerContent?.User_Suspended?.homePage?.suspended
                        }
                      </Typography>
                      <Box>
                        <Link role="button"
                          onClick={() => {
                            if (user?.billingSystem?.toUpperCase() === "ZUORA") {
                              addDwLogs(EC_DW_LOGGING_STEPS?.pay_now_attempted, "Suspended");
                              sendEventLog(EC_DW_LOGGING_STEPS?.pay_now_attempted, { "reason": "Suspended" });
                              sendEventGTMLog(`${EC_DW_LOGGING_STEPS?.pay_now_attempted}-Suspended}`, headers?.siteId || userCompanyName);
                            }
                          }}
                          className="anchorButton"
                          to="/my-bills/view-payments"
                        >
                          {
                            bannerContent?.User_Suspended?.homePage?.cta_make_payment
                          }
                        </Link>
                        {payInCash && <Link role="button"
                          className="anchorButtonSecondary"
                          to="/my-bills/view-payments"
                          onClick={() => { dispatch(setPayNowNotificationBtnClicked(true))
                            addDwLogs(EC_DW_LOGGING_STEPS?.suspended_user_pay_in_cash_cta_attempted)
                           }}
                        >
                          {
                            bannerContent?.User_Suspended?.homePage?.cta_pay_locations
                          }
                        </Link>}
                      </Box>
                    </Box>
                  ) : (
                    <Box className="notificationBannerWithCta">
                      <Typography paragraph variant="body1">
                        {payInCash ? bannerContent?.User_Suspended?.homePage?.jeopardy_cash :
                          bannerContent?.User_Suspended?.homePage?.jeopardy}
                      </Typography>
                      <Box>
                        <Link role="button"
                            onClick={() => {
                              addEneventGTM(
                                "EC_MakePayment_Banner_Link_click",
                                sessionId,
                                user?.billingAccountNumber,
                                userCompanyName
                              );
                              if (user?.billingSystem?.toUpperCase() === "ZUORA") {
                                addDwLogs(EC_DW_LOGGING_STEPS?.pay_now_attempted, "Jeopardy");
                                sendEventLog(EC_DW_LOGGING_STEPS?.pay_now_attempted, { "reason": "Jeopardy" });
                                sendEventGTMLog(`${EC_DW_LOGGING_STEPS?.pay_now_attempted}-Jeopardy}`, headers?.siteId || userCompanyName);
                              }
                            }}
                          className="anchorButton"
                          to="/my-bills/view-payments"
                        >
                          {
                            bannerContent?.User_Suspended?.homePage?.cta_make_payment
                          }
                        </Link>
                        {payInCash && <Link role="button"
                          className="anchorButtonSecondary"
                          to="/my-bills/view-payments"
                          onClick={() => { dispatch(setPayNowNotificationBtnClicked(true)) 
                              addDwLogs(EC_DW_LOGGING_STEPS?.jeopardy_user_pay_in_cash_cta_attempted)
                          }}
                        >
                          {
                            bannerContent?.User_Suspended?.homePage?.cta_pay_locations
                          }
                        </Link>}
                      </Box>
                    </Box>
                  )}
                </>
              )}

              {activeBanners[0]?.key === "User-Suspended" && currentPage === "view-payments" && (
                <>
                  {user?.currentStatus === "Suspended" ? (
                    <Box className="notificationBannerWithCta">
                      <Typography paragraph variant="body1" className="m-0">
                        {payInCash ? bannerContent?.User_Suspended?.myBills?.suspended_cash :
                          bannerContent?.User_Suspended?.homePage?.suspended}
                      </Typography>
                      <Box>
                        {payInCash ?
                          <Button
                            onClick={() => {
                              dispatch((setPayNowNotificationBtnClicked(true)))
                              addEneventGTM(
                                "EC_PayInCash_Banner_Link_click",
                                sessionId,
                                user?.billingAccountNumber,
                                userCompanyName
                              );
                              addDwLogs(
                                EC_DW_LOGGING_STEPS?.suspended_payincash_mybills_attempted
                              );
                            }}
                            className="notificationBannerButton"
                          >
                            {
                              bannerContent?.User_Suspended?.myBills?.cta_pay_in_cash
                            }
                          </Button> :
                          <Link role="button"
                            onClick={() => {
                              if (user?.billingSystem?.toUpperCase() === "ZUORA") {
                                addDwLogs(EC_DW_LOGGING_STEPS?.pay_now_attempted, "Suspended");
                                sendEventLog(EC_DW_LOGGING_STEPS?.pay_now_attempted, { "reason": "Suspended" });
                                sendEventGTMLog(`${EC_DW_LOGGING_STEPS?.pay_now_attempted}-Suspended}`, headers?.siteId || userCompanyName);
                              }
                            }}
                            className="anchorButton"
                            to="/my-bills/view-payments"
                          >
                            {
                              bannerContent?.User_Suspended?.homePage?.cta_make_payment
                            }
                          </Link>
                        }
                      </Box>
                    </Box>
                  ) : (
                    <Box className="notificationBannerWithCta">
                      <Typography paragraph variant="body1">
                        {payInCash ? bannerContent?.User_Suspended?.myBills?.jeopardy_cash :
                          bannerContent?.User_Suspended?.homePage?.jeopardy}
                      </Typography>
                      <Box>
                        {payInCash ? <Link role="button"
                          className="anchorButton"
                          to="/my-bills/view-payments"
                          onClick={() => { dispatch(setPayNowNotificationBtnClicked(true)) 
                             addDwLogs(
                                EC_DW_LOGGING_STEPS?.jeopardy_payincash_mybills_attempted
                              );
                          }}
                        >
                          {
                            bannerContent?.User_Suspended?.myBills?.cta_pay_in_cash
                          }
                        </Link> :
                          <Link role="button"
                              onClick={() => {
                                if (user?.billingSystem?.toUpperCase() === "ZUORA") {
                                  addDwLogs(EC_DW_LOGGING_STEPS?.pay_now_attempted, "Suspended");
                                  sendEventLog(EC_DW_LOGGING_STEPS?.pay_now_attempted, { "reason": "Suspended" });
                                  sendEventGTMLog(`${EC_DW_LOGGING_STEPS?.pay_now_attempted}-Suspended}`, headers?.siteId || userCompanyName);
                                }
                              }}
                            className="anchorButton"
                            to="/my-bills/view-payments"
                          >
                            {
                              bannerContent?.User_Suspended?.myBills?.cta_make_payment
                            }
                          </Link>}
                      </Box>
                    </Box>
                  )}
                </>
              )}

              {activeBanners[0]?.key === "User-Suspended" && currentPage === "plan-details" && (
                <>
                  {user?.currentStatus === "Suspended" ?
                    <Box className="notificationBannerWithCta">
                      <Typography paragraph variant="body1">
                        {bannerContent?.User_Suspended?.planDetails?.desc}
                      </Typography>
                      <Link role="button"
                        onClick={() => {
                          if (user?.billingSystem?.toUpperCase() === "ZUORA") {
                            addDwLogs(EC_DW_LOGGING_STEPS?.pay_now_attempted, "Suspended");
                            sendEventLog(EC_DW_LOGGING_STEPS?.pay_now_attempted, { "reason": "Suspended" });
                            sendEventGTMLog(`${EC_DW_LOGGING_STEPS?.pay_now_attempted}-Suspended}`, headers?.siteId || userCompanyName);
                          }
                        }}
                        className="anchorButton"
                        to={user?.billingType?.toUpperCase() === "POSTPAID" ? "/my-bills/quick-bill-payments" : "/my-bills/view-payments"}
                      >
                        {bannerContent?.User_Suspended?.planDetails?.cta_make_payment}
                      </Link>
                    </Box>
                    :
                    <Box className="notificationBannerWithCta">
                      <Typography paragraph variant="body1">
                        {bannerContent?.User_Suspended?.planDetails?.jeopardy}
                      </Typography>
                      <Link role="button"
                        onClick={() => {
                          if (user?.billingSystem?.toUpperCase() === "ZUORA") {
                            addDwLogs(EC_DW_LOGGING_STEPS?.pay_now_attempted, "Suspended");
                            sendEventLog(EC_DW_LOGGING_STEPS?.pay_now_attempted, { "reason": "Suspended" });
                            sendEventGTMLog(`${EC_DW_LOGGING_STEPS?.pay_now_attempted}-Suspended}`, headers?.siteId || userCompanyName);
                          }
                        }}
                        className="anchorButton"
                        to={user?.billingType?.toUpperCase() === "POSTPAID" ? "/my-bills/quick-bill-payments" : "/my-bills/view-payments"}
                      >
                        {bannerContent?.User_Suspended?.planDetails?.cta_make_payment}
                      </Link>
                    </Box>
                  }
                </>

              )}

              {activeBanners[0]?.key === "CCBanner" &&
                bannerContent?.CCBanner && (<Box className="notificationBannerWithCta creditCardBanner">
                  <Typography>
                    {replaceJSX(
                      bannerContent?.CCBanner?.expire_notification,
                      "<VALUE>",
                      isCreditCardExpirationNotificationShow,
                      "<VALUE1>",
                      (location?.pathname !== "/my-bills/payment-methods" || (location?.pathname === "/my-bills/payment-methods" && user?.billingType === "postpaid")) ? <Link role="button"
                        className="linkTextTopPx linkText buttonText"
                        key={nextMonthCreditCardExpDetails?.id}
                        to="/my-bills/payment-methods"
                      >
                      </Link> : " ",
                      "CCBanner"
                    )
                    }
                  </Typography>
                  {
                    (location?.pathname !== "/my-bills/payment-methods" || (location?.pathname === "/my-bills/payment-methods" && user?.billingType === "postpaid")) ? <Link role="button"
                      className="anchorButton"
                      key={nextMonthCreditCardExpDetails?.id}
                      style={{ cursor: "pointer" }}
                      onClick={ addDwLogs(EC_DW_LOGGING_STEPS?.cc_banner)}
                      to="/my-bills/payment-methods"
                    >
                      {bannerContent?.CCBanner?.updatenowlabel}
                    </Link> : " "
                  }
                </Box>)}


              {activeBanners[0]?.key === "RoadBoreBanner" && (
                <Typography>
                  <span className="roadBoreBanner_ques">
                    {bannerContent?.RoadBoreBanner?.desc1}
                  </span>{" "}
                  <span className="roadBoreBanner_title_ans pe-lg-2">
                    {bannerContent?.RoadBoreBanner?.desc2}
                  </span>
                </Typography>)}

              {activeBanners[0]?.key === "NEW_LOGIN" && (
                <Typography>
                  <span className="roadBoreBanner_ques">
                    {`We have recently enhanced our online security features. Please sign in below. If you need assistance, call 833-692-7773.`}
                    {/* <a
                      href="https://www.brightspeed.com/content/dam/brightspeed/pdfs/Forgot-Password.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        color: "#fff",        // always white
                        textDecoration: "underline", // always underlined
                        cursor: "pointer"     // pointer on hover
                      }}
                    >
                      {`these instructions`}
                    </a>{' '}
                    {`for our new experience.`} */}
                  </span>
                </Typography>
              )}


              {activeBanners[0]?.key === "BDBanner" &&
                <Typography>
                  {bannerContent?.BDBanner}
                </Typography>}


                {activeBanners[0]?.key === "EMBARGO_BANNER" &&
                <Typography>
                  {bannerContent?.Initial_login_CTL_Welcome?.desc4}
                </Typography>}


              {activeBanners[0]?.key === "Initial-login-CTL-Welcome" && (
                <Box className="notificationBannerWithCta">
                  <Box>
                    <Typography paragraph variant="body1">
                      {
                      bannerContent?.Initial_login_CTL_Welcome?.desc1
                      }
                    </Typography>
                   
                    <Typography paragraph variant="body1" className="mt-3">
                      {bannerContent?.Initial_login_CTL_Welcome?.desc2}
                    </Typography>
                   
                  </Box>
                  <Link role="button"
                    className="anchorButton"
                    to="/account-settings/account-info"
                  >
                    {bannerContent?.Initial_login_CTL_Welcome?.update_cta}
                  </Link>
                 
                </Box>)}


              {((activeBanners[0]?.key === "ReferalBanner")) && (
                <Box className="notificationBannerWithCta">
                  <Box>
                     <Typography className= "referalBannerDescHeader pb-3">
                      {referalBannerContent?.desc1}
                    </Typography>
                     <Typography className="referalBannerDescHeader">
                      {referalBannerContent?.desc2}
                     </Typography>
                     <Typography>
                     <button aria-label="Detailed terms" role="link"
                        className="referaldialoglink buttonText"
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          setReferalDialogOpen(true);
                          addDwLogs(EC_DW_LOGGING_STEPS?.referal_banner)
                        }}
                      >
                        {referalBannerContent?.desc3}
                      </button>{"."}
                     </Typography>
                  </Box>                 
                  <ExtoleReferal user={user} id={"banner"} />
                </Box>)}

              {activeBanners[0]?.key === "Initial-login-CTL-User" && (
                <Typography paragraph variant="body1">
                  {bannerContent?.Initial_login_CTL_User}{" "}
                </Typography>
              )}


              {activeBanners[0]?.key === "User-Suspended-Vacation" && (
                <>
                  {!isAfterBillingDate(user?.suspendStartDate) && (
                    <Box className="notificationBannerWithCta">
                      <Typography paragraph variant="body1" className="m-0">
                        {bannerContent?.User_Suspended_Vacation?.futurePause?.desc1}{" "}
                        {new Date(user?.suspendStartDate).toLocaleString(
                          "en-us",
                          {
                            timeZone: "UTC", 
                            month: "long",
                            day: "numeric",
                            year: "numeric",
                          }
                        )}{" "}
                        {bannerContent?.User_Suspended_Vacation?.futurePause?.desc2}{" "}
                        {new Date(user?.suspendEndDate).toLocaleString(
                          "en-us",
                          {
                            timeZone: "UTC",
                            month: "long",
                            day: "numeric",
                            year: "numeric",
                          }
                        )}
                        .{" "}
                        {bannerContent?.User_Suspended_Vacation?.futurePause?.desc3} {" "}
                        {(userType?.isPostPaidFiberUser && enablePPFChangeFlow) &&  bannerContent?.User_Suspended_Vacation?.futurePause?.chat_modify_pause}
                      </Typography>
                      {!userType?.isPostPaidFiberUser  && <Link role="button"
                        onClick={() => {
                          addEneventGTM(
                            "EC_Banner_Update_Pause_link_click",
                            sessionId,
                            user?.billingAccountNumber,
                            userCompanyName
                          )
                          addDwLogs(EC_DW_LOGGING_STEPS?.future_pause_cta)  
                        }}
                        className="anchorButton"
                        to="/pause-service"
                      >
                        {bannerContent?.User_Suspended_Vacation?.futurePause?.modify_pause_cta}
                      </Link>}
                    </Box>
                  )}
                  {user?.suspendReason?.toUpperCase() === "VACATION" &&
                    isAfterBillingDate(user?.suspendStartDate) && (
                      <Box className="notificationBannerWithCta">
                        <Typography paragraph variant="body1">
                          {bannerContent?.User_Suspended_Vacation?.currentPause?.desc1}{" "}
                          {new Date(user?.suspendEndDate).toLocaleString(
                            "en-us",
                            {
                              timeZone: "UTC",
                              month: "long",
                              day: "numeric",
                              year: "numeric",
                            }
                          )}
                          {bannerContent?.User_Suspended_Vacation?.currentPause?.desc2}{" "}
                          {bannerContent?.User_Suspended_Vacation?.currentPause?.desc3} {" "}
                          {(userType?.isPostPaidFiberUser && enablePPFChangeFlow) && bannerContent?.User_Suspended_Vacation?.currentPause?.chat_modify_pause}
                        </Typography>
                        {!userType?.isPostPaidFiberUser && <Link role="button"
                          onClick={() => {
                            addEneventGTM(
                              "EC_Banner_Update_Pause_link_click",
                              sessionId,
                              user?.billingAccountNumber,
                              userCompanyName
                            )
                            addDwLogs(EC_DW_LOGGING_STEPS?.current_pause_cta)  
                          }}
                          className="anchorButton"
                          to="/pause-service"
                        >
                          {bannerContent?.User_Suspended_Vacation?.currentPause?.cta_modify_pause}
                        </Link>}
                      </Box>
                    )}
                </>
              )}

              {activeBanners[0]?.key === "disableChangePlanFeatureNotification" && (
                <Box className="notificationBannerWithCta">
                  <Typography>
                    {bannerContent?.disableChangePlanFeatureNotification?.description}
                  </Typography>
                  <Link role="button" className="anchorButton" to="/my-bills/payment-methods">
                    {bannerContent?.disableChangePlanFeatureNotification?.add_cta}
                  </Link>
                </Box>)}


              {activeBanners[0]?.key === "changePlanPreInstallation" && (
                <Typography paragraph variant="body1">
                  {bannerContent?.changePlanPreInstallation}
                </Typography>
              )}

              {activeBanners[0]?.key === "changePlanPending" && (
                <Typography paragraph variant="body1">
                  {bannerContent?.changePlanPending}
                </Typography>
              )}

              {activeBanners[0]?.key === "Download-Banner" && (
                <Box className="notificationBannerWithCta">
                  <Typography className="text-spacing">
                    {bannerContent?.Download_Banner?.for_mobile_and_tablet_title}
                  </Typography>
                  <a role="button" className="anchorButton" target="_blank"
                    href="https://www.brightspeed.com/help/internet/fiber/account/app.html"
                    onClick={() => {
                      addDwLogs(EC_DW_LOGGING_STEPS?.download_app_banner)
                    }}>
                    {bannerContent?.Download_Banner?.cta_download}
                  </a>
                </Box>)}

              {activeBanners[0]?.key === "InstallationExtendBanner" &&
                <Typography>
                  {bannerContent?.installation_extended}
                </Typography>
              }

              {activeBanners[0]?.key === "PaymentArrangements" &&
                <Typography>
                  {bannerContent?.PaymentArrangements}
                </Typography>}


              {activeBanners[0]?.key === "ModemRestarted" && (
                <Typography paragraph variant="body1">
                  {bannerContent?.ModemRestarted}
                </Typography>
              )}



              {activeBanners[0]?.key === "AutoPayRemoval" &&
                <Typography>
                  {bannerContent?.AutoPayRemoval}
                </Typography>}

              {activeBanners[0]?.key === "qbpBanner" &&
                <Typography>
                  {bannerContent?.qbpBanner}
                </Typography>}


              {activeBanners[0]?.key === "User-Has-No-ACP" && (
                <Typography>
                  {bannerContent?.User_Has_No_ACP?.desc1}
                  <a
                    className="banner_here"
                    onClick={() => {
                      addEneventGTM(
                        "EC_ACP_Banner_Learn_More_Link_Click",
                        sessionId,
                        user?.billingAccountNumber,
                        userCompanyName
                      );
                    }}
                    href={bannerContent?.User_Has_No_ACP?.desc2}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {bannerContent?.User_Has_No_ACP?.desc3}
                  </a>{" "}
                  {bannerContent?.User_Has_No_ACP?.desc4}
                </Typography>)}

               {activeBanners[0]?.key === "DSL-Migrator" && (
                <Box className="notificationBannerWithCta">
                  <Typography paragraph variant="body1">
                    <Typography component="span" sx={{ fontWeight: 700 }}>
                      {bannerContent?.DSL_migrator_offer?.action_required}
                    </Typography>
                    {bannerContent?.DSL_migrator_offer?.desc_new}{" "}
                    <a className="buttonText" target="_blank" onClick={ addDwLogs(EC_DW_LOGGING_STEPS?.dsl_full_terms)}
                      href="https://www.brightspeed.com/aboutus/legal/consumer/brightspeed-fiber-plan-terms-launch/">
                      {bannerContent?.DSL_migrator_offer?.cta_full_terms?.replace(/\./, "")}
                    </a>{"."}
                  </Typography>
                  {/* <a className="anchorButton" href="https://shop.brightspeed.com/uas/" target="_blank">
                    {bannerContent?.DSL_migrator_offer?.cta_upgrade_now}
                  </a> */}
                </Box>
              )}

               {activeBanners[0]?.key === "POTS-Migrator-InEligible" && dslfibermigratorflow && (
                <Box className="notificationBannerWithCta">
                  <Typography paragraph variant="body1">
                    {/* <Typography component="span" sx={{ fontWeight: 700 }}>
                      {dslmigratornewbanner?.ineligible_dsl_banner?.ready_for_upgrade}
                    </Typography>  */}
                    {dslmigratornewbanner?.ineligible_dsl_banner?.desc}{" "}
                    <a className="buttonText" style={{color: "white"}} onClick={() => { chatClick() }} tabIndex={0}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          e.preventDefault();
                          chatClick();
                        }
                      }}>
                      {bannerContent?.ineligible_dsl_banner?.chat_now_cta}
                    </a>{" "}
                    {bannerContent?.ineligible_dsl_banner?.desc2} {" "}
                    <a className="buttonText" target="_blank" aria-label='Full terms opens in new tab'
                      href="https://www.brightspeed.com/aboutus/legal/consumer/brightspeed-fiber-plan-terms-launch/">
                      {dslmigratornewbanner?.ineligible_dsl_banner?.cta_full_terms?.replace(/\./, "")}
                    </a>
                  </Typography>
                </Box>
              )}

              {activeBanners[0]?.key === "IWP-InEligible" && dslfibermigratorflow && (
                    <Box className="notificationBannerWithCta">
                  <Typography paragraph variant="body1">
                   
                    {dslmigratornewbanner?.Migration_Inside_wire_protection?.desc}{" "}
                   
                    <a className="buttonText" target="_blank" aria-label='Full terms opens in new tab'
                      href="https://www.brightspeed.com/aboutus/legal/consumer/brightspeed-fiber-plan-terms-launch/">
                      {dslmigratornewbanner?.Migration_Inside_wire_protection?.full_terms_cta?.replace(/\./, "")}
                    </a>{"."}
                  </Typography>
                </Box>

              )}
            
               {activeBanners[0]?.key === "DSL-POTS-Migrator-Eligible" && dslfibermigratorflow &&(
                <Box className="notificationBannerWithCta">
                  <Typography paragraph variant="body1">
                    <Typography component="span" sx={{ fontWeight: 700 }}>
                      {dslmigratornewbanner?.eligible_dsl_pots_banner?.action_required}
                    </Typography>
                    {dslmigratornewbanner?.eligible_dsl_pots_banner?.desc}{" "}
                    <a className="buttonText" target="_blank" aria-label='Full terms opens in new tab'
                      href="https://www.brightspeed.com/aboutus/legal/consumer/brightspeed-fiber-plan-terms-launch/">
                      {dslmigratornewbanner?.eligible_dsl_pots_banner?.cta_full_terms?.replace(/\./, "")}
                    </a>{"."}
                  </Typography>
                  {!(currentPage === "plan-details") &&
                    <Link role="button" className="anchorButton" to="/account-settings/plan-details"
                      onClick={() => {
                        DwLogutil({ stepName: EC_DW_LOGGING_STEPS.start_now_banner_button_clicked, message:"DSL & POST Eligible user" })
                      }} >
                      {dslmigratornewbanner?.eligible_dsl_pots_banner?.cta_upgrade_now}
                    </Link>}
                </Box>
              )}

               {activeBanners[0]?.key === "POTS-Migrator-Eligible" && dslfibermigratorflow && (
                <Box className="notificationBannerWithCta">
                  <Typography paragraph variant="body1">
                    <Typography component="span" sx={{ fontWeight: 700 }}>
                      {dslmigratornewbanner?.dsl_banner_pots_only?.action_required}
                    </Typography>{" "}
                    {dslmigratornewbanner?.dsl_banner_pots_only?.desc}{" "}
                    <a className="buttonText" target="_blank" aria-label='Full terms opens in new tab'
                      href="https://www.brightspeed.com/aboutus/legal/consumer/brightspeed-fiber-plan-terms-launch/">
                      {dslmigratornewbanner?.dsl_banner_pots_only?.cta_full_terms?.replace(/\./, "")}
                    </a>{"."}
                  </Typography>
                  {!(currentPage === "plan-details") &&
                  <Link role="button" className="anchorButton" to="/account-settings/plan-details"
                    onClick={() => {
                      DwLogutil({ stepName: EC_DW_LOGGING_STEPS.start_now_banner_button_clicked, message: "POTS Only Eligible user" })
                    }}>
                    {dslmigratornewbanner?.dsl_banner_pots_only?.cta_upgrade_now}
                  </Link>}
                </Box>
              )}
              
               {activeBanners[0]?.key === 'DSL-Migrator-Eligible' && dslfibermigratorflow && (
                <Box className="notificationBannerWithCta">
                  <Typography paragraph variant="body1">
                    <Typography component="span" sx={{ fontWeight: 700 }}>
                      {dslmigratornewbanner?.dsl_only_banner?.action_required}
                    </Typography>
                    {dslmigratornewbanner?.dsl_only_banner?.desc}{" "}
                    <a className="buttonText" target="_blank" aria-label='Full terms opens in new tab'
                      href="https://www.brightspeed.com/aboutus/legal/consumer/brightspeed-fiber-plan-terms-launch/">
                      {dslmigratornewbanner?.dsl_only_banner?.cta_full_terms?.replace(/\./, "")}
                    </a>{"."}
                  </Typography>
                  {!(currentPage === "plan-details") &&
                  <Link role="button" className="anchorButton" to="/account-settings/plan-details"
                  onClick={() => {
                      DwLogutil({ stepName: EC_DW_LOGGING_STEPS.start_now_banner_button_clicked, message: "DSL Only Eligible user" })
                    }}>
                  {dslmigratornewbanner?.dsl_only_banner?.cta_upgrade_now}
                  </Link>}
                </Box>
              )}

              {activeBanners[0]?.key === "NEW_EQUIP_INSTALL" && (
                <Box className="notificationBannerWithCta">
                  <Typography variant="body1">
                    <Typography component="span" sx={{ fontWeight: 700 }}>
                      {bannerContent?.new_equip_install?.bold}{" "}
                      {getInternetSpeed(internetChangeNewPlanSpeed)}{"."}                   
                    </Typography>{" "}
                    {bannerContent?.new_equip_install?.desc}{" "}
                    <a className="buttonText" onClick={() => { chatClick() }} tabIndex={0}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          e.preventDefault();
                          chatClick();
                        }
                      }}>
                      {bannerContent?.new_equip_install?.chat_now_cta}
                    </a>{" "}
                    {bannerContent?.new_equip_install?.desc2}{" "}
                  </Typography>
                </Box>
              )}

              {activeBanners[0]?.key === "FIBER_MIGRATION_PENDING" && (
                <Box className="notificationBannerWithCta">
                  <Typography variant="body1">
                    <Typography component="span" sx={{ fontWeight: 700 }}>
                      {dslmigratornewbanner?.fiber_migration_pending?.bold}
                    </Typography>{" "}
                    {dslmigratornewbanner?.fiber_migration_pending?.desc}{" "}
                    <a className="buttonText" onClick={() => { chatClick() }} tabIndex={0}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          e.preventDefault();
                          chatClick();
                        }
                      }}>
                      {bannerContent?.fiber_migration_pending?.chat_now_cta}
                    </a>{" "}
                    {dslmigratornewbanner?.fiber_migration_pending?.desc2}{" "}
                  </Typography>
                </Box>
              )}

              {activeBanners[0]?.key === "FIBER_MIGRATION_SUCCESS" && (
                <Box className="notificationBannerWithCta">
                  <Typography variant="body1">
                    <Typography component="span" sx={{ fontWeight: 700 }}>
                      {dslmigratornewbanner?.fiber_migration_success?.bold}
                    </Typography>{" "}
                    {dslmigratornewbanner?.fiber_migration_success?.desc}{" "}
                  </Typography>
                  <Link role="button"
                    className="anchorButton"
                    to="/account-settings/plan-details"
                  >
                    {dslmigratornewbanner?.fiber_migration_success?.explore_plans_cta}
                  </Link>
                </Box>
              )}

              {activeBanners[0]?.key === "outageBanner" &&
              <>
              <Typography className="pe-1">
                  {bannerContent?.Outage_Information?.openOutage?.desc1}
                  <span className='bannerBoldText'>{` ${outageDate}`}</span>
                  <span>{bannerContent?.Outage_Information?.openOutage?.desc2}</span>
                  <span className='bannerBoldText'>{outageTime}</span>
                  <span>{bannerContent?.Outage_Information?.openOutage?.desc3}</span>
                </Typography>
                 <Typography className="mt-3 pr-1">
                  {bannerContent?.Outage_Information?.openOutage?.desc4}
                  <Link role="link"
                    className="buttonText"
                    to="/account-settings/account-info#commPref"
                  >
                    {bannerContent?.Outage_Information?.comm_pref_cta}
                  </Link>
                  {bannerContent?.Outage_Information?.openOutage?.desc5}
                </Typography>
                </>
              }

              {activeBanners[0]?.key === "outageRestoreBanner" &&
                <>
                <Typography>
                  {bannerContent?.Outage_Information?.restoreOutage?.desc1}
                </Typography>
                 <Typography className="mt-3 pr-1">
                  {bannerContent?.Outage_Information?.restoreOutage?.desc2}
                  <Link role="link"
                    className="buttonText"
                    to="/account-settings/account-info#commPref"
                  >
                    {bannerContent?.Outage_Information?.comm_pref_cta}
                  </Link>
                  {bannerContent?.Outage_Information?.restoreOutage?.desc3}
                </Typography>
                </>
              }

              {activeBanners[0]?.key === "BRSPD_No_Outage" && (
                <Typography>
                  {bannerContent?.Outage_Information?.brspdNoOutage?.desc1}
                  <button aria-label="download the Brightspeed WiFi app opens in new tab" className="buttonText" role='link'
                   onClick={() => {
                    window.open(bannerContent?.Outage_Information?.brspdNoOutage?.href,"_blank")
                    DwLogutil({stepName: EC_DW_LOGGING_STEPS.nooutage_wifi_app_click_banner})
                  }}
                   >
                    {bannerContent?.Outage_Information?.download_brspd_wifi_app_cta}
                  </button>
                  {bannerContent?.Outage_Information?.brspdNoOutage?.desc2}
                  <Link role="link"
                    onClick={() => {
                      DwLogutil({stepName: EC_DW_LOGGING_STEPS.nooutage_bs_comm_pref_click_banner})
                    }}
                    className="buttonText"
                    to="/account-settings/account-info#commPref"
                  >
                    {bannerContent?.Outage_Information?.comm_pref_cta}
                  </Link>.
                </Typography>
              )}

              {activeBanners[0]?.key === "Othrs_No_Outage" && (
                <Typography>
                  <span>{bannerContent?.Outage_Information?.othrsNoOutage?.desc1}</span>
                  <button aria-label="try restarting your router opens in new tab" className="buttonText" role='link'
                   onClick={() => {
                    window.open(bannerContent?.Outage_Information?.othrsNoOutage?.href,"_blank")
                    DwLogutil({stepName: EC_DW_LOGGING_STEPS.nooutage_restart_click_banner})
                   }}
                   >
                    {bannerContent?.Outage_Information?.try_restart_cta}
                  </button>
                  <span>{bannerContent?.Outage_Information?.othrsNoOutage?.desc2}</span>
                  <Link role="link"
                    onClick={() => {
                      DwLogutil({ stepName: EC_DW_LOGGING_STEPS.nooutage_othr_comm_pref_click_banner })
                    }}
                    className="buttonText"
                    to="/account-settings/account-info#commPref"
                  >
                    {bannerContent?.Outage_Information?.comm_pref_cta}
                  </Link>.
                </Typography>
              )}

              {/* removed Banner style of 5th Dec & updated with 2026 Jan style */}
              {activeBanners[0]?.key === "DSL-POTS-Migrator-Eligible" && DSL_BANNER_CHANGE_ENABLED && (
                <Typography>
                  <span>{bannerContent?.DSL_POTS_Migrator_Eligible?.bold}</span> {" "}
                  {bannerContent?.DSL_POTS_Migrator_Eligible?.desc} {" "}
                  {/* <a className="buttonText" onClick={()=>{chatClick()}} tabIndex={0}>
                    {bannerContent?.DSL_POTS_Migrator_Eligible?.chat_now_cta}
                  </a>{" "} */}
                  {bannerContent?.DSL_POTS_Migrator_Eligible?.desc2} {" "}
                  <button aria-label="Full Terms opens in new tab" className="buttonText" role='link' onClick={() => window.open(bannerContent?.DSL_POTS_Migrator_Eligible?.href,"_blank")}>
                    {bannerContent?.DSL_POTS_Migrator_Eligible?.full_terms_cta}
                  </button>.
                </Typography>
              )}

              {/* removed Banner style of 5th Dec & updated with 2026 Jan style */}
              {activeBanners[0]?.key === "DSL-Migrator-Eligible" && DSL_BANNER_CHANGE_ENABLED && (
                <Typography>
                  <span className='bannerBoldText'>{bannerContent?.DSL_Migrator_Eligible?.bold}</span> {" "}
                  {bannerContent?.DSL_Migrator_Eligible?.desc} {" "}
                  {/* <a className="buttonText" onClick={()=>{chatClick()}} tabIndex={0}>
                    {bannerContent?.DSL_Migrator_Eligible?.chat_now_cta}
                  </a>{" "} */}
                  {bannerContent?.DSL_Migrator_Eligible?.desc2} {" "}
                  <button aria-label="Full Terms opens in new tab" className="buttonText" role='link' onClick={() => window.open(bannerContent?.DSL_Migrator_Eligible?.href, "_blank")}>
                    {bannerContent?.DSL_Migrator_Eligible?.full_terms_cta}
                  </button>.
                </Typography>
              )}

              {/* removed Banner style of 5th Dec & updated with 2026 Jan style */}
              {activeBanners[0]?.key === "POTS-Migrator-Eligible" && DSL_BANNER_CHANGE_ENABLED && (
                <Typography>
                  <span className='bannerBoldText'>{bannerContent?.POTS_Migrator_Eligible?.bold}</span> {" "}
                  {bannerContent?.POTS_Migrator_Eligible?.desc} {" "}
                  {/* <a className="buttonText" onClick={()=>{chatClick()}} tabIndex={0}>
                    {bannerContent?.POTS_Migrator_Eligible?.chat_now_cta}
                  </a>{" "} */}
                  {bannerContent?.POTS_Migrator_Eligible?.desc2} {" "}
                  <button aria-label="Full Terms opens in new tab" className="buttonText" role='link' onClick={() => window.open(bannerContent?.POTS_Migrator_Eligible?.href, "_blank")}>
                    {bannerContent?.POTS_Migrator_Eligible?.full_terms_cta}
                  </button>.
                </Typography>
              )}

              
              {/* removed Banner style of 5th Dec & updated with 2026 Jan style */}
              {activeBanners[0]?.key === "POTS-Migrator-InEligible" && DSL_BANNER_CHANGE_ENABLED && (
                <Typography>
                  <span className='bannerBoldText'>{bannerContent?.DSL_Migrator_InEligible?.bold}</span> {" "}
                  {bannerContent?.DSL_Migrator_InEligible?.desc} {" "}
                  {/* <a className="buttonText" onClick={()=>{chatClick()}} tabIndex={0}>
                    {bannerContent?.DSL_Migrator_InEligible?.chat_now_cta}
                  </a>{" "} */}
                  {bannerContent?.DSL_Migrator_InEligible?.desc2} {" "}
                  <button aria-label="Full Terms opens in new tab" className="buttonText" role='link' onClick={() => window.open(bannerContent?.DSL_Migrator_InEligible?.href, "_blank")}>
                    {bannerContent?.DSL_Migrator_InEligible?.full_terms_cta}
                  </button>.
                </Typography>)}


              {activeBanners[0]?.key === "BRSPD_VAS" && (
                <Box className="notificationBannerWithCta">
                  <Typography variant="body1" component="p" className="normal-letter-spacing">
                    {bannerContent?.BRSPD_VAS?.desc}
                  </Typography>
                  <Link role="button"
                    className="anchorButton"
                    to="/account-settings/plan-details"
                  >
                    {bannerContent?.BRSPD_VAS?.explore_cta}
                  </Link>
                </Box>
              )}

              {activeBanners[0]?.key === "FQF_VAS" && (
                <Box className="notificationBannerWithCta">
                  <Typography variant="body1" component="p" className="normal-letter-spacing">
                    {bannerContent?.FQF_VAS?.desc}
                  </Typography>
                  <Link role="button"
                    className="anchorButton"
                    to="/account-settings/plan-details"
                  >
                    {bannerContent?.FQF_VAS?.enroll_cta}
                  </Link>
                </Box>
              )}

            </Box>
          </Box>
         { !hideclose && activeBanners[0]?.key !== "BRSPD_No_Outage" && activeBanners[0]?.key !== "Othrs_No_Outage" && getImageSrc(activeBanners[0]?.key) !== null && <Box className="warnCloseIcon">
            <Typography component="button" className="btnText p-0"
              onClick={() => {
                onCloseBanner(activeBanners[0]?.key)
              }}
            >
              <img
                src={closeIcon}
                alt="Close the alert"
                className="cursor-pointer" />
            </Typography>
          </Box>}
        </Box>
      }
      {referalDialogOpen &&
        <ReferalDialog
          isOpen={referalDialogOpen}
          close={() => {
            setReferalDialogOpen(false);
          }}
        />
      }
      {showAppDialog &&
        <AppDownlaodDialog
          isOpen={showAppDialog}
          close={() => {
            setShowAppDialog(false);
          }}
        />
      }
    </>
  );
};

export default BannerComponent;
